import { render } from "./EditWorkHis.vue?vue&type=template&id=a81569d8"
import script from "./EditWorkHis.vue?vue&type=script&lang=js"
export * from "./EditWorkHis.vue?vue&type=script&lang=js"

import exportComponent from "I:\\JavaWork\\Recruit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__